
export enum TipoPagamento {

    CARTAO_CREDITO = "Cartão de crédito",
    PIX = "PIX",
    NENHUM = "Nenhum",

}